"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDrelateState = exports.defaultDrelateSections = exports.defaultDrelateLinks = void 0;
exports.defaultDrelateLinks = [
    { name: 'Discovery Bay', url: 'https://okay.com' },
    { name: 'Discovery Bay', url: 'https://okay.com' },
    { name: 'Discovery Bay', url: 'https://okay.com' },
    { name: 'Discovery Bay', url: 'https://okay.com' },
    { name: 'Discovery Bay', url: 'https://okay.com' },
    { name: 'Discovery Bay', url: 'https://okay.com' },
    { name: 'Discovery Bay', url: 'https://okay.com' },
    { name: 'Discovery Bay', url: 'https://okay.com' },
    { name: 'Discovery Bay', url: 'https://okay.com' },
    { name: 'Discovery Bay', url: 'https://okay.com' },
    { name: 'Discovery Bay', url: 'https://okay.com' },
    { name: 'Discovery Bay', url: 'https://okay.com' },
    { name: 'Discovery Bay', url: 'https://okay.com' },
];
exports.defaultDrelateSections = [
    { title: 'Popular District Searches - For Sale', links: exports.defaultDrelateLinks },
    { title: 'Popular District Searches - For Sale', links: exports.defaultDrelateLinks },
    { title: 'Popular District Searches - For Sale', links: exports.defaultDrelateLinks },
    { title: 'Popular District Searches - For Sale', links: exports.defaultDrelateLinks },
];
exports.defaultDrelateState = {
    sections: exports.defaultDrelateSections,
};
